webpackJsonp([266772403791747],{

/***/ 321:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ArticleFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(77);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var title = _ref.title,
	        image = _ref.image,
	        date = _ref.date,
	        datetime = _ref.datetime,
	        slug = _ref.slug;
	    return _react2.default.createElement(
	        'article',
	        { className: 'article-card' },
	        _react2.default.createElement(
	            'figure',
	            { className: 'article-card__figure' },
	            _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' + slug },
	                _react2.default.createElement(_gatsbyImage2.default, {
	                    alt: image.alt,
	                    sizes: image.localFile.childImageSharp.sizes,
	                    style: { display: 'block' }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'header',
	            { className: 'article-card__header' },
	            _react2.default.createElement(
	                'div',
	                { className: 'article-card__meta' },
	                _react2.default.createElement(
	                    'time',
	                    { dateTime: datetime },
	                    date
	                )
	            ),
	            _react2.default.createElement(
	                'h2',
	                { className: 'article-card__title' },
	                _react2.default.createElement(_gatsbyLink2.default, { to: '/' + slug, dangerouslySetInnerHTML: { __html: title } })
	            )
	        )
	    );
	};
	
	var ArticleFragment = exports.ArticleFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(77);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(330);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var children = _ref.children,
	        items = _ref.items;
	    return _react2.default.createElement(
	        'div',
	        { className: 'image-grid' },
	        items.map(function (item) {
	            return _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: item.hyperlink, className: 'image-grid__item' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    item.text
	                ),
	                _react2.default.createElement(_gatsbyImage2.default, { alt: item.image.alt, sizes: item.image.localFile.childImageSharp.sizes })
	            );
	        })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(195);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(139);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Header = __webpack_require__(138);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(137);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var children = _ref.children,
	        config = _ref.config,
	        hero = _ref.hero;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { defaultTitle: config.name, titleTemplate: '%s | ' + config.name, title: hero.title }),
	        _react2.default.createElement(_Header2.default, { name: config.name, description: config.description }),
	        _react2.default.createElement(
	            'main',
	            { className: 'main', role: 'main', id: 'main' },
	            _react2.default.createElement(_Hero2.default, hero),
	            children
	        ),
	        _react2.default.createElement(_Footer2.default, { name: config.name })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var text = _ref.text,
	        author = _ref.author,
	        color = _ref.color;
	    return _react2.default.createElement(
	        'blockquote',
	        { className: 'quote' },
	        _react2.default.createElement(
	            'svg',
	            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512', style: { fill: '#23ab3c' } },
	            _react2.default.createElement('path', { d: 'M125.89 235.04c4.5-34.09 34.63-64.95 89.76-91.84l9.93-4.84-40.7-75.14-9.19 4.65C59.11 126.97 0 210.48 0 316.1c0 36.44 11.57 67.92 34.38 93.55 23.14 26 51.22 39.17 83.46 39.17 28.98 0 53.55-10.32 73.03-30.67 19.35-20.22 29.16-45.33 29.16-74.65 0-27.7-9.91-52.38-29.46-73.37-17.24-18.51-38.97-30.28-64.68-35.09zm49.68 168.47c-15.55 16.24-34.43 24.14-57.73 24.14-26.3 0-48.43-10.5-67.64-32.08-19.53-21.94-29.03-47.94-29.03-79.47 0-48.4 13.63-92.11 40.52-129.9 25.64-36.04 64.11-67.87 114.44-94.7l20.38 37.65c-61.32 32.13-92.38 70.76-92.38 114.92v9.46l9.39 1.06c25.3 2.87 45.44 12.67 61.56 29.97 16 17.18 23.78 36.46 23.78 58.94 0 24.01-7.62 43.64-23.29 60.01zM413.2 235.07c4.45-34.12 34.34-65 89.03-91.89l9.77-4.8-39.69-75.2-9.28 4.68c-117.1 59.1-176.49 142.61-176.49 248.24 0 36.47 11.72 67.96 34.82 93.6 23.4 25.96 51.59 39.12 83.8 39.12 29.02 0 53.47-10.34 72.7-30.73 19.05-20.2 28.71-45.3 28.71-74.59 0-27.7-9.91-52.38-29.46-73.37-17.2-18.47-38.67-30.24-63.9-35.06zm49.25 168.5c-15.28 16.2-34.01 24.08-57.28 24.08-26.33 0-48.6-10.51-68.08-32.13-19.77-21.93-29.38-47.91-29.38-79.42 0-48.4 13.7-92.1 40.7-129.87 25.76-36.04 64.4-67.87 114.93-94.69l19.84 37.59c-60.88 32.14-91.73 70.78-91.73 114.94v9.44l9.37 1.08c24.79 2.86 44.68 12.67 60.8 29.97 16 17.18 23.78 36.46 23.78 58.94 0 24.04-7.5 43.69-22.95 60.07z' })
	        ),
	        _react2.default.createElement('div', { className: 'quote__body', dangerouslySetInnerHTML: { __html: text } }),
	        _react2.default.createElement(
	            'footer',
	            { className: 'quote__author' },
	            author
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(77);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Quote = __webpack_require__(224);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	__webpack_require__(333);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var text = _ref.text,
	        author = _ref.author,
	        image = _ref.image,
	        quoteColor = _ref.quoteColor;
	    return _react2.default.createElement(
	        'div',
	        { className: 'quote-box' },
	        _react2.default.createElement(
	            'div',
	            { className: 'quote-box__image' },
	            _react2.default.createElement(_gatsbyImage2.default, { alt: image.alt, sizes: image.localFile.childImageSharp.sizes })
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'quote-box__body' },
	            _react2.default.createElement(_Quote2.default, { text: text, author: author, color: quoteColor })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Band = __webpack_require__(136);
	
	var _Band2 = _interopRequireDefault(_Band);
	
	var _QuoteBox = __webpack_require__(225);
	
	var _QuoteBox2 = _interopRequireDefault(_QuoteBox);
	
	var _ImageGrid = __webpack_require__(221);
	
	var _ImageGrid2 = _interopRequireDefault(_ImageGrid);
	
	var _WideLayout = __webpack_require__(222);
	
	var _WideLayout2 = _interopRequireDefault(_WideLayout);
	
	var _ArticleCard = __webpack_require__(216);
	
	var _ArticleCard2 = _interopRequireDefault(_ArticleCard);
	
	var _Grid = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeTemplate = function (_Component) {
	    _inherits(HomeTemplate, _Component);
	
	    function HomeTemplate() {
	        _classCallCheck(this, HomeTemplate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    HomeTemplate.prototype.render = function render() {
	        var _props$data = this.props.data,
	            page = _props$data.page,
	            config = _props$data.config,
	            posts = _props$data.posts;
	
	        return _react2.default.createElement(
	            _WideLayout2.default,
	            { config: config, hero: { image: page.hero, title: config.description, height: '100vh' } },
	            page.content && _react2.default.createElement(
	                _Band2.default,
	                { bgColor: '#ece9e7' },
	                _react2.default.createElement('div', { style: { textAlign: 'center' }, dangerouslySetInnerHTML: { __html: page.content } })
	            ),
	            page.acf.image_grid && _react2.default.createElement(
	                _Band2.default,
	                null,
	                _react2.default.createElement(_ImageGrid2.default, { items: page.acf.image_grid })
	            ),
	            page.acf.quote && _react2.default.createElement(
	                _Band2.default,
	                { bgColor: '#23ab3c' },
	                _react2.default.createElement(_QuoteBox2.default, _extends({}, page.acf.quote, { iconColor: '#23ab3c' }))
	            ),
	            posts && _react2.default.createElement(
	                _Band2.default,
	                { title: 'Recent Articles' },
	                _react2.default.createElement(
	                    _Grid.Row,
	                    { style: { marginBottom: '-35px' } },
	                    posts.edges.map(function (post) {
	                        return _react2.default.createElement(
	                            _Grid.Column,
	                            { sm: '4' },
	                            _react2.default.createElement(_ArticleCard2.default, post.node)
	                        );
	                    })
	                )
	            )
	        );
	    };
	
	    return HomeTemplate;
	}(_react.Component);
	
	exports.default = HomeTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-js-9c6059691091dcbf6afb.js